import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SystemApiClient } from "../clients/system-api/SystemApiClientp";
import { PaginationArgs, AdministrationResultStatus, ServiceCategoryDataPaginationDataAdministrationResult, ServiceCategoryData, ServiceCategoryDataAdministrationResult } from "../clients/system-api/SystemApiClient";

@Injectable({
    providedIn: 'root'
  })
  export class ServiceCategoryService {
    constructor (private systemApiClient: SystemApiClient) { }

    retrieveAllServiceCategories(): Observable<ServiceCategoryDataPaginationDataAdministrationResult>{
        return this.systemApiClient.retrieveAllServiceCategories();
    }

    retrieveAllServiceCategoriesPaginated(body: PaginationArgs | undefined): Observable<ServiceCategoryDataPaginationDataAdministrationResult>{
        return this.systemApiClient.retrieveAllServiceCategoriesPaginated(body);
    }

    addServiceCategory(body: ServiceCategoryData | undefined): Observable<AdministrationResultStatus>    {
        return this.systemApiClient.addServiceCategory(body);
    }

    editServiceCategory(body: ServiceCategoryData | undefined): Observable<AdministrationResultStatus>{
        return this.systemApiClient.editServiceCategory(body);
    }

    retriveServiceCategoryById(serviceCategoryId: number | undefined): Observable<ServiceCategoryDataAdministrationResult>{
        return this.systemApiClient.retrieveServiceCategoryById(serviceCategoryId);
    }
}